import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/search';

const namespace = 'CI';

export const FETCH_CODEFILE_START = `${namespace}/FETCH_CODEFILE_START`;
export const FETCH_CODEFILE_SUCCESS = `${namespace}/FETCH_CODEFILE_SUCCESS`;
export const FETCH_CODEFILE_ERROR = `${namespace}/FETCH_CODEFILE_START`;

export const FETCH_SEARCH_CONFIG_START = `${namespace}/FETCH_SEARCH_CONFIG_START`;
export const FETCH_SEARCH_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_CONFIG_SUCCESS`;
export const FETCH_SEARCH_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_CONFIG_ERROR`;

export const FETCH_SEARCH_RESULTS_CONFIG_START = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_START`;
export const FETCH_SEARCH_RESULTS_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_SUCCESS`;
export const FETCH_SEARCH_RESULTS_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_ERROR`;

export const SEARCH_START = `${namespace}/SEARCH_START`;
export const SEARCH_SUCCESS = `${namespace}/SEARCH_SUCCESS`;
export const SEARCH_ERROR = `${namespace}/SEARCH_ERROR`;

export const EXECUTE_SMARTLIST_QUERY_START = `${namespace}/EXECUTE_SMARTLIST_QUERY_START`;
export const EXECUTE_SMARTLIST_QUERY_SUCCESS = `${namespace}/EXECUTE_SMARTLIST_QUERY_SUCCESS`;
export const EXECUTE_SMARTLIST_QUERY_ERROR = `${namespace}/EXECUTE_SMARTLIST_QUERY_ERROR`;

export const DELETE_CI_RECORD_START = `${namespace}/DELETE_CI_RECORD_START`;
export const DELETE_CI_RECORD_SUCCESS = `${namespace}/DELETE_CI_RECORD_SUCCESS`;
export const DELETE_CI_RECORD_ERROR = `${namespace}/DELETE_CI_RECORD_ERROR`;

export const CREATE_CI_RECORD_START = `${namespace}/CREATE_CI_RECORD_START`;
export const CREATE_CI_RECORD_SUCCESS = `${namespace}/CREATE_CI_RECORD_SUCCESS`;
export const CREATE_CI_RECORD_ERROR = `${namespace}/CREATE_CI_RECORD_ERROR`;

export const EDIT_CI_RECORD_START = `${namespace}/EDIT_CI_RECORD_START`;
export const EDIT_CI_RECORD_SUCCESS = `${namespace}/EDIT_CI_RECORD_SUCCESS`;
export const EDIT_CI_RECORD_ERROR = `${namespace}/EDIT_CI_RECORD_ERROR`;

export const SAVE_SKETCH_START = `${namespace}/SAVE_SKETCH_START`;
export const SAVE_SKETCH_SUCCESS = `${namespace}/SAVE_SKETCH_SUCCESS`;
export const SAVE_SKETCH_ERROR = `${namespace}/SAVE_SKETCH_ERROR`;

export const UPDATE_CI_RECORD_START = `${namespace}/UPDATE_CI_RECORD_START`;
export const UPDATE_CI_RECORD_SUCCESS = `${namespace}/UPDATE_CI_RECORD_SUCCESS`;
export const UPDATE_CI_RECORD_ERROR = `${namespace}/UPDATE_CI_RECORD_ERROR`;

export const POST_COMMENT_START = `${namespace}/POST_COMMENT_START`;
export const POST_COMMENT_SUCCESS = `${namespace}/POST_COMMENT_SUCCESS`;
export const POST_COMMENT_ERROR = `${namespace}/POST_COMMENT_ERROR`;

export const GET_COMMENTS_START = `${namespace}/GET_COMMENTS_START`;
export const GET_COMMENTS_SUCCESS = `${namespace}/GET_COMMENTS_SUCCESS`;
export const GET_COMMENTS_ERROR = `${namespace}/GET_COMMENTS_ERROR`;

export const DELETE_COMMENT_START = `${namespace}/DELETE_COMMENT_START`;
export const DELETE_COMMENT_SUCCESS = `${namespace}/DELETE_COMMENT_SUCCESS`;
export const DELETE_COMMENT_ERROR = `${namespace}/DELETE_COMMENT_ERROR`;

export const POST_TAG_START = `${namespace}/POST_TAG_START`;
export const POST_TAG_SUCCESS = `${namespace}/POST_TAG_SUCCESS`;
export const POST_TAG_ERROR = `${namespace}/POST_TAG_ERROR`;

export const GET_TAGS_START = `${namespace}/GET_TAGS_START`;
export const GET_TAGS_SUCCESS = `${namespace}/GET_TAGS_SUCCESS`;
export const GET_TAGS_ERROR = `${namespace}/GET_TAGS_ERROR`;

export const GET_PID_ADDRESS_DATA_START = `${namespace}/GET_PID_ADDRESS_DATA_START`;
export const GET_PID_ADDRESS_DATA_SUCCESS = `${namespace}/GET_PID_ADDRESS_DATA_SUCCESS`;
export const GET_PID_ADDRESS_DATA_ERROR = `${namespace}/GET_PID_ADDRESS_DATA_ERROR`;

export const GET_TAXING_UNITS_START = `${namespace}/GET_TAXING_UNITS_START`;
export const GET_TAXING_UNITS_SUCCESS = `${namespace}/GET_TAXING_UNITS_SUCCESS`;
export const GET_TAXING_UNITS_ERROR = `${namespace}/GET_TAXING_UNITS_ERROR`;

export const DELETE_TAG_START = `${namespace}/DELETE_TAG_START`;
export const DELETE_TAG_SUCCESS = `${namespace}/DELETE_TAG_SUCCESS`;
export const DELETE_TAG_ERROR = `${namespace}/DELETE_TAG_ERROR`;

export const SET_INITIAL_SKETCH_DATA_START = `${namespace}/SET_INITIAL_SKETCH_DATA_START`;
export const SET_INITIAL_SKETCH_DATA_SUCCESS = `${namespace}/SET_INITIAL_SKETCH_DATA_SUCCESS`;
export const SET_INITIAL_SKETCH_DATA_ERROR = `${namespace}/SET_INITIAL_SKETCH_DATA_ERROR`;

export const GET_PROPERTY_SEARCH_DATA_START = `${namespace}/GET_PROPERTY_SEARCH_DATA_START`;
export const GET_PROPERTY_SEARCH_DATA_SUCCESS = `${namespace}/GET_PROPERTY_SEARCH_DATA_SUCCESS`;
export const GET_PROPERTY_SEARCH_DATA_ERROR = `${namespace}/GET_PROPERTY_SEARCH_DATA_ERROR`;

export const GET_APPRAISAL_SEARCH_DATA_START = `${namespace}/GET_APPRAISAL_SEARCH_DATA_START`;
export const GET_APPRAISAL_SEARCH_DATA_SUCCESS = `${namespace}/GET_APPRAISAL_SEARCH_DATA_SUCCESS`;
export const GET_APPRAISAL_SEARCH_DATA_ERROR = `${namespace}/GET_APPRAISAL_SEARCH_DATA_ERROR`;

export const GET_POPUP_CONTENT_START = `${namespace}/GET_POPUP_CONTENT_START`;
export const GET_POPUP_CONTENT_SUCCESS = `${namespace}/GET_POPUP_CONTENT_SUCCESS`;
export const GET_POPUP_CONTENT_ERROR = `${namespace}/GET_POPUP_CONTENT_ERROR`;

export const GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_START = `${namespace}/GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_START`;
export const GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_SUCCESS = `${namespace}/GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_SUCCESS`;
export const GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_ERROR = `${namespace}/GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_ERROR`;

export const GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_START = `${namespace}/GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_START`;
export const GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_SUCCESS = `${namespace}/GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_SUCCESS`;
export const GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_ERROR = `${namespace}/GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_ERROR`;

export const GET_APPRAISAL_CI_POPUP_CONTENT_START = `${namespace}/GET_APPRAISAL_CI_POPUP_CONTENT_START`;
export const GET_APPRAISAL_CI_POPUP_CONTENT_SUCCESS = `${namespace}/GET_APPRAISAL_CI_POPUP_CONTENT_SUCCESS`;
export const GET_APPRAISAL_CI_POPUP_CONTENT_ERROR = `${namespace}/GET_APPRAISAL_CI_POPUP_CONTENT_ERROR`;

export const GET_CI_API_SETTINGS_START = `${namespace}/GET_CI_API_SETTINGS_START`;
export const GET_CI_API_SETTINGS_SUCCESS = `${namespace}/GET_CI_API_SETTINGS_SUCCESS`;
export const GET_CI_API_SETTINGS_ERROR = `${namespace}/GET_CI_API_SETTINGS_ERROR`;

export const SET_CI_API_SETTINGS_START = `${namespace}/SET_CI_API_SETTINGS_START`;
export const SET_CI_API_SETTINGS_SUCCESS = `${namespace}/SET_CI_API_SETTINGS_SUCCESS`;
export const SET_CI_API_SETTINGS_ERROR = `${namespace}/SET_CI_API_SETTINGS_ERROR`;

export const GET_GIS_API_SETTINGS_START = `${namespace}/GET_GIS_API_SETTINGS_START`;
export const GET_GIS_API_SETTINGS_SUCCESS = `${namespace}/GET_GIS_API_SETTINGS_SUCCESS`;
export const GET_GIS_API_SETTINGS_ERROR = `${namespace}/GET_GIS_API_SETTINGS_ERROR`;

export const SET_GIS_API_SETTINGS_START = `${namespace}/SET_GIS_API_SETTINGS_START`;
export const SET_GIS_API_SETTINGS_SUCCESS = `${namespace}/SET_GIS_API_SETTINGS_SUCCESS`;
export const SET_GIS_API_SETTINGS_ERROR = `${namespace}/SET_GIS_API_SETTINGS_ERROR`;

export const GET_APPRAISAL_CI_INITIAL_DATA_START = `${namespace}/GET_APPRAISAL_CI_INITIAL_DATA_START`;
export const GET_APPRAISAL_CI_INITIAL_DATA_SUCCESS = `${namespace}/GET_APPRAISAL_CI_INITIAL_DATA_SUCCESS`;
export const GET_APPRAISAL_CI_INITIAL_DATA_ERROR = `${namespace}/GET_APPRAISAL_CI_INITIAL_DATA_ERROR`;

export const EXECUTE_SMART_LIST_QUERY_START = `${namespace}/EXECUTE_SMART_LIST_QUERY_START`;
export const EXECUTE_SMART_LIST_QUERY_SUCCESS = `${namespace}/EXECUTE_SMART_LIST_QUERY_SUCCESS`;
export const EXECUTE_SMART_LIST_QUERY_ERROR = `${namespace}/EXECUTE_SMART_LIST_QUERY_ERROR`;

export const SEARCH_BY_ABSTRACT_NUMBER_START = `${namespace}/SEARCH_BY_ABSTRACT_NUMBER_START`;
export const SEARCH_BY_ABSTRACT_NUMBER_SUCCESS = `${namespace}/SEARCH_BY_ABSTRACT_NUMBER_SUCCESS`;
export const SEARCH_BY_ABSTRACT_NUMBER_ERROR = `${namespace}/SEARCH_BY_ABSTRACT_NUMBER_ERROR`;

export const SEARCH_BY_ABSTRACT_NAME_START = `${namespace}/SEARCH_BY_ABSTRACT_NAME_START`;
export const SEARCH_BY_ABSTRACT_NAME_SUCCESS = `${namespace}/SEARCH_BY_ABSTRACT_NAME_SUCCESS`;
export const SEARCH_BY_ABSTRACT_NAME_ERROR = `${namespace}/SEARCH_BY_ABSTRACT_NAME_ERROR`;

export const SEARCH_BY_SUBDIVISION_NAME_START = `${namespace}/SEARCH_BY_SUBDIVISION_NAME_START`;
export const SEARCH_BY_SUBDIVISION_NAME_SUCCESS = `${namespace}/SEARCH_BY_SUBDIVISION_NAME_SUCCESS`;
export const SEARCH_BY_SUBDIVISION_NAME_ERROR = `${namespace}/SEARCH_BY_SUBDIVISION_NAME_ERROR`;

export const SEARCH_BY_MARKETAREA_NAME_START = `${namespace}/SEARCH_BY_MARKETAREA_NAME_START`;
export const SEARCH_BY_MARKETAREA_NAME_SUCCESS = `${namespace}/SEARCH_BY_MARKETAREA_NAME_SUCCESS`;
export const SEARCH_BY_MARKETAREA_NAME_ERROR = `${namespace}/SEARCH_BY_MARKETAREA_NAME_ERROR`;

export const GET_PARCEL_LABEL_DATA_START = `${namespace}/GET_PARCEL_LABEL_DATA_START`;
export const GET_PARCEL_LABEL_DATA_SUCCESS = `${namespace}/GET_PARCEL_LABEL_DATA_SUCCESS`;
export const GET_PARCEL_LABEL_DATA_ERROR = `${namespace}/GET_PARCEL_LABEL_DATA_ERROR`;

export const GET_POSTGIS_PARCEL_DATA_START = `${namespace}/GET_POSTGIS_PARCEL_DATA_START`;
export const GET_POSTGIS_PARCEL_DATA_SUCCESS = `${namespace}/GET_POSTGIS_PARCEL_DATA_SUCCESS`;
export const GET_POSTGIS_PARCEL_DATA_ERROR = `${namespace}/GET_POSTGIS_PARCEL_DATA_ERROR`;

export const GET_PARCELS_WITHIN_BOUNDS_START = `${namespace}/GET_PARCELS_WITHIN_BOUNDS_START`;
export const GET_PARCELS_WITHIN_BOUNDS_SUCCESS = `${namespace}/GET_PARCELS_WITHIN_BOUNDS_SUCCESS`;
export const GET_PARCELS_WITHIN_BOUNDS_ERROR = `${namespace}/GET_PARCELS_WITHIN_BOUNDS_ERROR`;

export const GET_PARCELS_INFO_WITHIN_BOUNDS_START = `${namespace}/GET_PARCELS_INFO_WITHIN_BOUNDS_START`;
export const GET_PARCELS_INFO_WITHIN_BOUNDS_SUCCESS = `${namespace}/GET_PARCELS_INFO_WITHIN_BOUNDS_SUCCESS`;
export const GET_PARCELS_INFO_WITHIN_BOUNDS_ERROR = `${namespace}/GET_PARCELS_INFO_WITHIN_BOUNDS_ERROR`;

export const GET_FEATURE_FROM_COORDINATES_START = `${namespace}/GET_FEATURE_FROM_COORDINATES_START`;
export const GET_FEATURE_FROM_COORDINATES_SUCCESS = `${namespace}/GET_FEATURE_FROM_COORDINATES_SUCCESS`;
export const GET_FEATURE_FROM_COORDINATES_ERROR = `${namespace}/GET_FEATURE_FROM_COORDINATES_START`;

export const GET_COUNTY_ABSTRACT_DATA_START = `${namespace}/GET_COUNTY_ABSTRACT_DATA_START`;
export const GET_COUNTY_ABSTRACT_DATA_SUCCESS = `${namespace}/GET_COUNTY_ABSTRACT_DATA_SUCCESS`;
export const GET_COUNTY_ABSTRACT_DATA_ERROR = `${namespace}/GET_COUNTY_ABSTRACT_DATA_START`;

export const GET_SYMBOLOGY_SUBSET_DATA_START = `${namespace}/GET_SYMBOLOGY_SUBSET_DATA_START`;
export const GET_SYMBOLOGY_SUBSET_DATA_SUCCESS = `${namespace}/GET_SYMBOLOGY_SUBSET_DATA_SUCCESS`;
export const GET_SYMBOLOGY_SUBSET_DATA_ERROR = `${namespace}/GET_SYMBOLOGY_SUBSET_DATA_START`;

export const SET_INITIAL_SKETCH_MODIFIER = `${namespace}/SET_INITIAL_SKETCH_MODIFIER`;

export const SET_APPRAISALMAPDATA = `${namespace}/SET_APPRAISALMAPDATA`;

export const SET_MAPDATA = `${namespace}/SET_MAPDATA`;

export const SET_GISSETTINGS = `${namespace}/SET_GISSETTINGS`;

export const SET_GISSETTINGSSTATE = `${namespace}/SET_GISSETTINGSSTATE`;

export const SET_CISETTINGS = `${namespace}/SET_CISETTINGS`;

export const SET_MAPCOORDS = `${namespace}/SET_MAPCOORDS`;

export const SET_APPRAISALMAPCOORDS = `${namespace}/SET_APPRAISALMAPCOORDS`;

export const fetchCodeFile = makeApiActionCreatorV3(
  api.fetchCodeFile,
  FETCH_CODEFILE_START,
  FETCH_CODEFILE_SUCCESS,
  FETCH_CODEFILE_ERROR,
);

export const getParcelsInfoWithinBounds = makeApiActionCreatorV3(
  api.getParcelsInfoWithinBounds,
  GET_PARCELS_INFO_WITHIN_BOUNDS_START,
  GET_PARCELS_INFO_WITHIN_BOUNDS_SUCCESS,
  GET_PARCELS_INFO_WITHIN_BOUNDS_ERROR,
);

export const deleteCiRecord = makeApiActionCreatorV3(
  api.deleteCiRecord,
  DELETE_CI_RECORD_START,
  DELETE_CI_RECORD_SUCCESS,
  DELETE_CI_RECORD_ERROR,
);

export const editCiRecord = makeApiActionCreatorV3(
  api.editCiRecord,
  EDIT_CI_RECORD_START,
  EDIT_CI_RECORD_SUCCESS,
  EDIT_CI_RECORD_ERROR,
);

export const executeSmartlistQuery = makeApiActionCreatorV3(
  api.executeSmartlistQuery,
  EXECUTE_SMART_LIST_QUERY_START,
  EXECUTE_SMART_LIST_QUERY_SUCCESS,
  EXECUTE_SMART_LIST_QUERY_ERROR,
);

export const executeSmartlistQueryCi = makeApiActionCreatorV3(
  api.executeSmartlistQueryCi,
  EXECUTE_SMART_LIST_QUERY_START,
  EXECUTE_SMART_LIST_QUERY_SUCCESS,
  EXECUTE_SMART_LIST_QUERY_ERROR,
);

export const fetchSearchConfig = makeApiActionCreatorV3(
  api.fetchSearchConfig,
  FETCH_SEARCH_CONFIG_START,
  FETCH_SEARCH_CONFIG_SUCCESS,
  FETCH_SEARCH_CONFIG_ERROR,
);

export const fetchSearchResultsConfig = makeApiActionCreatorV3(
  api.fetchSearchResultsConfig,
  FETCH_SEARCH_RESULTS_CONFIG_START,
  FETCH_SEARCH_RESULTS_CONFIG_SUCCESS,
  FETCH_SEARCH_RESULTS_CONFIG_ERROR,
);

export const createCiRecord = makeApiActionCreatorV3(
  api.createCiRecord,
  CREATE_CI_RECORD_START,
  CREATE_CI_RECORD_SUCCESS,
  CREATE_CI_RECORD_ERROR,
);

export const saveSketch = makeApiActionCreatorV3(
  api.saveSketch,
  SAVE_SKETCH_START,
  SAVE_SKETCH_SUCCESS,
  SAVE_SKETCH_ERROR,
);

export const updateCiRecord = makeApiActionCreatorV3(
  api.updateCiRecord,
  UPDATE_CI_RECORD_START,
  UPDATE_CI_RECORD_SUCCESS,
  UPDATE_CI_RECORD_ERROR,
);

export const search = makeApiActionCreatorV3(
  api.search,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_ERROR,
);

export const postComment = makeApiActionCreatorV3(
  api.postComment,
  POST_COMMENT_START,
  POST_COMMENT_SUCCESS,
  POST_COMMENT_ERROR,
);

export const getComments = makeApiActionCreatorV3(
  api.getComments,
  GET_COMMENTS_START,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_ERROR,
);

export const deleteComment = makeApiActionCreatorV3(
  api.deleteComment,
  DELETE_COMMENT_START,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_ERROR,
);

export const postTag = makeApiActionCreatorV3(
  api.postTag,
  POST_TAG_START,
  POST_TAG_SUCCESS,
  POST_TAG_ERROR,
);

export const getTaxingUnits = makeApiActionCreatorV3(
  api.getTaxingUnits,
  GET_TAXING_UNITS_START,
  GET_TAXING_UNITS_SUCCESS,
  GET_TAXING_UNITS_ERROR,
);

export const getTags = makeApiActionCreatorV3(
  api.getTags,
  GET_TAGS_START,
  GET_TAGS_SUCCESS,
  GET_TAGS_ERROR,
);

export const getPidAddressData = makeApiActionCreatorV3(
  api.getPropertyData,
  GET_PID_ADDRESS_DATA_START,
  GET_PID_ADDRESS_DATA_SUCCESS,
  GET_PID_ADDRESS_DATA_ERROR,
);

export const deleteTag = makeApiActionCreatorV3(
  api.deleteTag,
  DELETE_TAG_START,
  DELETE_TAG_SUCCESS,
  DELETE_TAG_ERROR,
);

export const setInitialSketchData = makeApiActionCreatorV3(
  api.editCiRecord,
  SET_INITIAL_SKETCH_DATA_START,
  SET_INITIAL_SKETCH_DATA_SUCCESS,
  SET_INITIAL_SKETCH_DATA_ERROR,
);

export const getCiApiSettings = makeApiActionCreatorV3(
  api.getCiApiSettings,
  GET_CI_API_SETTINGS_START,
  GET_CI_API_SETTINGS_SUCCESS,
  GET_CI_API_SETTINGS_ERROR,
);

export const setCiApiSettings = makeApiActionCreatorV3(
  api.setCiApiSettings,
  SET_CI_API_SETTINGS_START,
  SET_CI_API_SETTINGS_SUCCESS,
  SET_CI_API_SETTINGS_ERROR,
);

export const getFeatureFromCoordinates = makeApiActionCreatorV3(
  api.getFeatureFromCoordinates,
  GET_FEATURE_FROM_COORDINATES_START,
  GET_FEATURE_FROM_COORDINATES_SUCCESS,
  GET_FEATURE_FROM_COORDINATES_ERROR,
);

export const getGisApiSettings = makeApiActionCreatorV3(
  api.getGisApiSettings,
  GET_GIS_API_SETTINGS_START,
  GET_GIS_API_SETTINGS_SUCCESS,
  GET_GIS_API_SETTINGS_ERROR,
);

export const setGisApiSettings = makeApiActionCreatorV3(
  api.setGisApiSettings,
  SET_GIS_API_SETTINGS_START,
  SET_GIS_API_SETTINGS_SUCCESS,
  SET_GIS_API_SETTINGS_ERROR,
);

export const getPropertySearchData = makeApiActionCreatorV3(
  api.getPropertySearchData,
  GET_PROPERTY_SEARCH_DATA_START,
  GET_PROPERTY_SEARCH_DATA_SUCCESS,
  GET_PROPERTY_SEARCH_DATA_ERROR,
);

export const getAppraisalSearchData = makeApiActionCreatorV3(
  api.getAppraisalSearchData,
  GET_APPRAISAL_SEARCH_DATA_START,
  GET_APPRAISAL_SEARCH_DATA_SUCCESS,
  GET_APPRAISAL_SEARCH_DATA_ERROR,
);

export const getPopupContent = makeApiActionCreatorV3(
  api.getPropertySearchData,
  GET_POPUP_CONTENT_START,
  GET_POPUP_CONTENT_SUCCESS,
  GET_POPUP_CONTENT_ERROR,
);

export const getAppraisalCiPropertySearchData = makeApiActionCreatorV3(
  api.getPropertySearchData,
  GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_START,
  GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_SUCCESS,
  GET_APPRAISAL_CI_PROPERTY_SEARCH_DATA_ERROR,
);

export const getAppraisalCiAppraisalSearchData = makeApiActionCreatorV3(
  api.getAppraisalSearchData,
  GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_START,
  GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_SUCCESS,
  GET_APPRAISAL_CI_APPRAISAL_SEARCH_DATA_ERROR,
);

export const getAppraisalCiPopupContent = makeApiActionCreatorV3(
  api.getPropertySearchData,
  GET_APPRAISAL_CI_POPUP_CONTENT_START,
  GET_APPRAISAL_CI_POPUP_CONTENT_SUCCESS,
  GET_APPRAISAL_CI_POPUP_CONTENT_ERROR,
);

export const getAppraisalCiInitialData = makeApiActionCreatorV3(
  api.getAppraisalCiInitialData,
  GET_APPRAISAL_CI_INITIAL_DATA_START,
  GET_APPRAISAL_CI_INITIAL_DATA_SUCCESS,
  GET_APPRAISAL_CI_INITIAL_DATA_ERROR,
);

export const getCountyAbstractData = makeApiActionCreatorV3(
  api.getCountyAbstractData,
  GET_COUNTY_ABSTRACT_DATA_START,
  GET_COUNTY_ABSTRACT_DATA_SUCCESS,
  GET_COUNTY_ABSTRACT_DATA_ERROR,
);

export const searchByAbstract = makeApiActionCreatorV3(
  api.searchByAbstract,
  SEARCH_BY_ABSTRACT_NUMBER_START,
  SEARCH_BY_ABSTRACT_NUMBER_SUCCESS,
  SEARCH_BY_ABSTRACT_NUMBER_ERROR,
);

export const searchByAbstractNumber = makeApiActionCreatorV3(
  api.searchByAbstractNumber,
  SEARCH_BY_ABSTRACT_NUMBER_START,
  SEARCH_BY_ABSTRACT_NUMBER_SUCCESS,
  SEARCH_BY_ABSTRACT_NUMBER_ERROR,
);

export const searchByAbstractName = makeApiActionCreatorV3(
  api.searchByAbstractName,
  SEARCH_BY_ABSTRACT_NAME_START,
  SEARCH_BY_ABSTRACT_NAME_SUCCESS,
  SEARCH_BY_ABSTRACT_NAME_ERROR,
);

export const searchBySubdivisionName = makeApiActionCreatorV3(
  api.searchBySubdivisionName,
  SEARCH_BY_SUBDIVISION_NAME_START,
  SEARCH_BY_SUBDIVISION_NAME_SUCCESS,
  SEARCH_BY_SUBDIVISION_NAME_ERROR,
);

export const searchByMarketAreaName = makeApiActionCreatorV3(
  api.searchByMarketAreaName,
  SEARCH_BY_MARKETAREA_NAME_START,
  SEARCH_BY_MARKETAREA_NAME_SUCCESS,
  SEARCH_BY_MARKETAREA_NAME_ERROR,
);

export const getParcelLabelData = makeApiActionCreatorV3(
  api.getParcelLabelData,
  GET_PARCEL_LABEL_DATA_START,
  GET_PARCEL_LABEL_DATA_SUCCESS,
  GET_PARCEL_LABEL_DATA_ERROR,
);

export const getPostGisParcelData = makeApiActionCreatorV3(
  api.getPostGisParcelData,
  GET_POSTGIS_PARCEL_DATA_START,
  GET_POSTGIS_PARCEL_DATA_SUCCESS,
  GET_POSTGIS_PARCEL_DATA_ERROR,
);

export const getParcelsWithinBounds = makeApiActionCreatorV3(
  api.getParcelsWithinBounds,
  GET_PARCELS_WITHIN_BOUNDS_START,
  GET_PARCELS_WITHIN_BOUNDS_SUCCESS,
  GET_PARCELS_WITHIN_BOUNDS_ERROR,
);

export const getSymbologySubsetData = makeApiActionCreatorV3(
  api.getSymbologySubsetData,
  GET_SYMBOLOGY_SUBSET_DATA_START,
  GET_SYMBOLOGY_SUBSET_DATA_SUCCESS,
  GET_SYMBOLOGY_SUBSET_DATA_ERROR,
);

export const getSymbologySubsetLandData = makeApiActionCreatorV3(
  api.getSymbologySubsetLandData,
  GET_SYMBOLOGY_SUBSET_DATA_START,
  GET_SYMBOLOGY_SUBSET_DATA_SUCCESS,
  GET_SYMBOLOGY_SUBSET_DATA_ERROR,
);

export function setAppraisalMapData(data) {
  return async dispatch => {
    dispatch({ type: SET_APPRAISALMAPDATA, windowData: data });
  };
}

export function setMapData(data) {
  return async dispatch => {
    dispatch({ type: SET_MAPDATA, windowData: data });
  };
}

export function setGisSettings(data) {
  return async dispatch => {
    dispatch({ type: SET_GISSETTINGS, windowData: data });
  };
}

export function setGisSettingsState(data) {
  return async dispatch => {
    dispatch({ type: SET_GISSETTINGSSTATE, windowData: data });
  };
}

export function setCiSettings(data) {
  return async dispatch => {
    dispatch({ type: SET_CISETTINGS, windowData: data });
  };
}

export function setMapCoords(data) {
  return async dispatch => {
    dispatch({ type: SET_MAPCOORDS, windowData: data });
  };
}

export function setAppraisalMapCoords(data) {
  return async dispatch => {
    dispatch({ type: SET_APPRAISALMAPCOORDS, windowData: data });
  };
}

export function setInitialSketchModifier(modifier) {
  return async dispatch => {
    dispatch({ type: SET_INITIAL_SKETCH_MODIFIER, sketchData: modifier });
  };
}
